module.exports = __webpack_public_path__ + "img/wozx.cd5618b6.svg";